import { subscribeSteps } from "@/mocks/comicGuide";

export default function Subscription() {
  return (
    <section id="subscribe" className="relative overflow-hidden bg-primary-500 py-14 text-background-50 md:py-20">
      <div className="pointer-events-none absolute -right-10 -top-10 h-52 w-52 rounded-full bg-primary-400/40"></div>
      <div className="pointer-events-none absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-accent-500/30"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium">
              <i className="ri-notification-3-line"></i> 订阅提醒
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl">追更不再靠缘分，更新秒知道</h2>
            <p className="mt-4 text-base leading-relaxed text-background-100">
              订阅提醒把喜欢的人气新作集中管理，新章节更新即时推送，配合更新日历与免打扰模式，追更节奏尽在掌握，再也不用担心漏看。
            </p>
            <a
              href="#faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-3 text-sm font-medium text-primary-600 transition hover:bg-background-100"
            >
              订阅相关常见问题 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="space-y-4">
            {subscribeSteps.map((s, idx) => (
              <div key={s.title} className="flex items-start gap-4 rounded-2xl bg-background-50/10 p-5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-400 text-primary-950">
                  {idx + 1}
                </span>
                <div>
                  <h3 className="text-base font-bold">{s.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-background-100">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}